import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  intro: {
    mb: '24px'
  } satisfies SxProps<Theme>,
  pane: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    border: '2px solid var(--purple-500)',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: 'var(--purple-50)'
  } satisfies SxProps<Theme>,
  rail: {
    width: { xs: '100%', md: '271px' },
    flexShrink: 0,
    backgroundColor: 'var(--grey-100)',
    borderRight: { md: '2px solid var(--purple-500)' }
  } satisfies SxProps<Theme>,
  railHeader: {
    backgroundColor: 'var(--purple-500)',
    px: '16px',
    py: '10px'
  } satisfies SxProps<Theme>,
  railHeaderText: {
    color: 'var(--white)',
    fontWeight: 700
  } satisfies SxProps<Theme>,
  railHint: {
    backgroundColor: 'var(--purple-100)',
    px: '16px',
    py: '10px'
  } satisfies SxProps<Theme>,
  railList: {
    py: '8px',
    px: 0
  } satisfies SxProps<Theme>,
  railItem: {
    alignItems: 'flex-start',
    gap: '10px',
    px: '16px',
    py: '8px',
    '&.Mui-selected': { backgroundColor: 'var(--white)', borderRight: '8px solid var(--purple-500)' },
    '&.Mui-selected:hover': { backgroundColor: 'var(--white)' },
    '&:hover': { backgroundColor: 'var(--grey-300)' }
  } satisfies SxProps<Theme>,
  railItemTick: {
    width: '24px',
    flexShrink: 0,
    mt: '2px'
  } satisfies SxProps<Theme>,
  completeCard: {
    m: '8px',
    mt: '4px',
    backgroundColor: 'var(--purple-500)',
    borderRadius: '12px',
    p: '20px',
    textAlign: 'center'
  } satisfies SxProps<Theme>,
  completeButton: {
    backgroundColor: 'var(--white)',
    color: 'var(--grey-700)',
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': { backgroundColor: 'var(--purple-50)' }
  } satisfies SxProps<Theme>,
  formPanel: {
    flexGrow: 1,
    p: { xs: '16px', md: '24px' }
  } satisfies SxProps<Theme>,
  formHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px'
  } satisfies SxProps<Theme>,
  lastUpdated: {
    color: 'text.secondary',
    whiteSpace: 'nowrap',
    mt: '8px'
  } satisfies SxProps<Theme>,
  submittedBy: {
    color: 'var(--green-700)',
    display: 'block',
    fontWeight: 600
  } satisfies SxProps<Theme>,
  requiredHint: {
    color: 'text.secondary',
    display: 'block',
    mb: '16px'
  } satisfies SxProps<Theme>
}
